module.exports = "https://r.nearpod.com/assets/media/image/mail-icon-05394eda671dd781f8170a17830025cc.svg";